module.exports = __webpack_public_path__ + "static/rs-stone-footer-f4bc17ebdf924df12438e854ac97e57b.svg";